
class Images {
    async readImages(files, {max, maxSize, }) {
        let result = null;
        files.length > max
            ? result = {error: `Максимум загружаемых фотографий: ${max}`}
            : '';
        if (!result) {
            result = []
            for (let index = 0; index < files.length; index++) {
                const element = files[index];
                if (index < max) {
                    if (element.size / 1024 > (maxSize * 1000)) {
                        result = {error: `Размер одной из загружаемых фотографий превышает ${max}MB`}
                    } else {
                        let url = await new Promise((resolve) => {
                            const reader = new FileReader()
                            reader.onloadend = () => resolve(reader.result)
                            reader.readAsDataURL(element)
                        });
                        let measurements = await new Promise ((resolved) => {
                            var i = new Image();
                            i.onload = function(){
                                resolved({w: i.width, h: i.height})
                            };
                            i.src = url
                        })
                        let orientation = measurements.w > measurements.h ? 'landscape' : 'portrait';
                        result.push({
                            url: url,
                            orientation: orientation,
                            type: element.type.split('/')[1],
                            size: element.size / 1024,
                            measurements: measurements,
                            name: element.name.split('.')[0]
                        });
                    }
                }
            }
        }
        return result
    }

}

module.exports = new Images();